// Icone dell'app: solo Lucide. <v-icon>nome</v-icon> accetta il nome Lucide
// (kebab-case) o uno dei nomi storici in ALIASES.

import TriangleAlert from "lucide/dist/esm/icons/triangle-alert.mjs";
import ArrowLeft from "lucide/dist/esm/icons/arrow-left.mjs";
import ArrowRight from "lucide/dist/esm/icons/arrow-right.mjs";
import ArrowUp from "lucide/dist/esm/icons/arrow-up.mjs";
import ArrowDown from "lucide/dist/esm/icons/arrow-down.mjs";
import ChartColumn from "lucide/dist/esm/icons/chart-column.mjs";
import ChartPie from "lucide/dist/esm/icons/chart-pie.mjs";
import Bell from "lucide/dist/esm/icons/bell.mjs";
import BellOff from "lucide/dist/esm/icons/bell-off.mjs";
import Calendar from "lucide/dist/esm/icons/calendar.mjs";
import CalendarCheck from "lucide/dist/esm/icons/calendar-check.mjs";
import CalendarDays from "lucide/dist/esm/icons/calendar-days.mjs";
import X from "lucide/dist/esm/icons/x.mjs";
import Check from "lucide/dist/esm/icons/check.mjs";
import CircleCheck from "lucide/dist/esm/icons/circle-check.mjs";
import CircleX from "lucide/dist/esm/icons/circle-x.mjs";
import CircleAlert from "lucide/dist/esm/icons/circle-alert.mjs";
import CircleQuestionMark from "lucide/dist/esm/icons/circle-question-mark.mjs";
import Circle from "lucide/dist/esm/icons/circle.mjs";
import Info from "lucide/dist/esm/icons/info.mjs";
import ChevronDown from "lucide/dist/esm/icons/chevron-down.mjs";
import ChevronUp from "lucide/dist/esm/icons/chevron-up.mjs";
import ChevronLeft from "lucide/dist/esm/icons/chevron-left.mjs";
import ChevronRight from "lucide/dist/esm/icons/chevron-right.mjs";
import Copy from "lucide/dist/esm/icons/copy.mjs";
import Settings from "lucide/dist/esm/icons/settings.mjs";
import Ban from "lucide/dist/esm/icons/ban.mjs";
import GripVertical from "lucide/dist/esm/icons/grip-vertical.mjs";
import SquarePen from "lucide/dist/esm/icons/square-pen.mjs";
import Pencil from "lucide/dist/esm/icons/pencil.mjs";
import Mail from "lucide/dist/esm/icons/mail.mjs";
import MailCheck from "lucide/dist/esm/icons/mail-check.mjs";
import Download from "lucide/dist/esm/icons/download.mjs";
import Upload from "lucide/dist/esm/icons/upload.mjs";
import FileSpreadsheet from "lucide/dist/esm/icons/file-spreadsheet.mjs";
import FilePlus from "lucide/dist/esm/icons/file-plus.mjs";
import FileText from "lucide/dist/esm/icons/file-text.mjs";
import Layers from "lucide/dist/esm/icons/layers.mjs";
import Menu from "lucide/dist/esm/icons/menu.mjs";
import Image from "lucide/dist/esm/icons/image.mjs";
import Ellipsis from "lucide/dist/esm/icons/ellipsis.mjs";
import EllipsisVertical from "lucide/dist/esm/icons/ellipsis-vertical.mjs";
import Palette from "lucide/dist/esm/icons/palette.mjs";
import Paperclip from "lucide/dist/esm/icons/paperclip.mjs";
import Plus from "lucide/dist/esm/icons/plus.mjs";
import Minus from "lucide/dist/esm/icons/minus.mjs";
import Search from "lucide/dist/esm/icons/search.mjs";
import LoaderCircle from "lucide/dist/esm/icons/loader-circle.mjs";
import Square from "lucide/dist/esm/icons/square.mjs";
import ClipboardList from "lucide/dist/esm/icons/clipboard-list.mjs";
import ClipboardX from "lucide/dist/esm/icons/clipboard-x.mjs";
import ClipboardCheck from "lucide/dist/esm/icons/clipboard-check.mjs";
import Trash from "lucide/dist/esm/icons/trash.mjs";
import SlidersHorizontal from "lucide/dist/esm/icons/sliders-horizontal.mjs";
import Users from "lucide/dist/esm/icons/users.mjs";
import User from "lucide/dist/esm/icons/user.mjs";
import UserPlus from "lucide/dist/esm/icons/user-plus.mjs";
import LogOut from "lucide/dist/esm/icons/log-out.mjs";
import KeyRound from "lucide/dist/esm/icons/key-round.mjs";
import RefreshCw from "lucide/dist/esm/icons/refresh-cw.mjs";
import RotateCcw from "lucide/dist/esm/icons/rotate-ccw.mjs";
import Lock from "lucide/dist/esm/icons/lock.mjs";
import Eye from "lucide/dist/esm/icons/eye.mjs";
import EyeOff from "lucide/dist/esm/icons/eye-off.mjs";
import Funnel from "lucide/dist/esm/icons/funnel.mjs";
import QrCode from "lucide/dist/esm/icons/qr-code.mjs";
import Link from "lucide/dist/esm/icons/link.mjs";
import ExternalLink from "lucide/dist/esm/icons/external-link.mjs";
import CornerDownRight from "lucide/dist/esm/icons/corner-down-right.mjs";
import ListChecks from "lucide/dist/esm/icons/list-checks.mjs";
import List from "lucide/dist/esm/icons/list.mjs";
import Pill from "lucide/dist/esm/icons/pill.mjs";
import MessageCircle from "lucide/dist/esm/icons/message-circle.mjs";
import Send from "lucide/dist/esm/icons/send.mjs";
import Clock from "lucide/dist/esm/icons/clock.mjs";
import Star from "lucide/dist/esm/icons/star.mjs";
import Globe from "lucide/dist/esm/icons/globe.mjs";
import Save from "lucide/dist/esm/icons/save.mjs";
import House from "lucide/dist/esm/icons/house.mjs";
import Stethoscope from "lucide/dist/esm/icons/stethoscope.mjs";
import ShieldCheck from "lucide/dist/esm/icons/shield-check.mjs";
import Database from "lucide/dist/esm/icons/database.mjs";
import Hash from "lucide/dist/esm/icons/hash.mjs";
import Type from "lucide/dist/esm/icons/type.mjs";
import ToggleLeft from "lucide/dist/esm/icons/toggle-left.mjs";
import Sigma from "lucide/dist/esm/icons/sigma.mjs";
import Inbox from "lucide/dist/esm/icons/inbox.mjs";
import SearchX from "lucide/dist/esm/icons/search-x.mjs";
import Power from "lucide/dist/esm/icons/power.mjs";
import CloudCheck from "lucide/dist/esm/icons/cloud-check.mjs";

export type IconNode = Array<[string, Record<string, string | number>]>;

const ICONS: Record<string, IconNode> = {
  "triangle-alert": TriangleAlert,
  "arrow-left": ArrowLeft,
  "arrow-right": ArrowRight,
  "arrow-up": ArrowUp,
  "arrow-down": ArrowDown,
  "chart-column": ChartColumn,
  "chart-pie": ChartPie,
  "bell": Bell,
  "bell-off": BellOff,
  "calendar": Calendar,
  "calendar-check": CalendarCheck,
  "calendar-days": CalendarDays,
  "x": X,
  "check": Check,
  "circle-check": CircleCheck,
  "circle-x": CircleX,
  "circle-alert": CircleAlert,
  "circle-question-mark": CircleQuestionMark,
  "circle": Circle,
  "info": Info,
  "chevron-down": ChevronDown,
  "chevron-up": ChevronUp,
  "chevron-left": ChevronLeft,
  "chevron-right": ChevronRight,
  "copy": Copy,
  "settings": Settings,
  "ban": Ban,
  "grip-vertical": GripVertical,
  "square-pen": SquarePen,
  "pencil": Pencil,
  "mail": Mail,
  "mail-check": MailCheck,
  "download": Download,
  "upload": Upload,
  "file-spreadsheet": FileSpreadsheet,
  "file-plus": FilePlus,
  "file-text": FileText,
  "layers": Layers,
  "menu": Menu,
  "image": Image,
  "ellipsis": Ellipsis,
  "ellipsis-vertical": EllipsisVertical,
  "palette": Palette,
  "paperclip": Paperclip,
  "plus": Plus,
  "minus": Minus,
  "search": Search,
  "loader-circle": LoaderCircle,
  "square": Square,
  "clipboard-list": ClipboardList,
  "clipboard-x": ClipboardX,
  "clipboard-check": ClipboardCheck,
  "trash": Trash,
  "sliders-horizontal": SlidersHorizontal,
  "users": Users,
  "user": User,
  "user-plus": UserPlus,
  "log-out": LogOut,
  "key-round": KeyRound,
  "refresh-cw": RefreshCw,
  "rotate-ccw": RotateCcw,
  "lock": Lock,
  "eye": Eye,
  "eye-off": EyeOff,
  "funnel": Funnel,
  "qr-code": QrCode,
  "link": Link,
  "external-link": ExternalLink,
  "corner-down-right": CornerDownRight,
  "list-checks": ListChecks,
  "list": List,
  "pill": Pill,
  "message-circle": MessageCircle,
  "send": Send,
  "clock": Clock,
  "star": Star,
  "globe": Globe,
  "save": Save,
  "house": House,
  "stethoscope": Stethoscope,
  "shield-check": ShieldCheck,
  "database": Database,
  "hash": Hash,
  "type": Type,
  "toggle-left": ToggleLeft,
  "sigma": Sigma,
  "inbox": Inbox,
  "search-x": SearchX,
  "power": Power,
  "cloud-check": CloudCheck,
};

const ALIASES: Record<string, string> = {
  "alert": "triangle-alert",
  "arrow": "arrow-right",
  "back": "arrow-left",
  "bar-chart": "chart-column",
  "charts": "chart-column",
  "pie-chart": "chart-pie",
  "pie": "chart-pie",
  "calendar-selected": "calendar-check",
  "cancel": "x",
  "close": "x",
  "modal-close": "x",
  "white-close": "x",
  "check-symbol": "check",
  "check2": "check",
  "checked": "circle-check",
  "clone": "copy",
  "cog": "settings",
  "disabled": "ban",
  "enable": "circle-check",
  "doctors": "users",
  "groups": "layers",
  "drag": "grip-vertical",
  "edit-note": "square-pen",
  "edit": "pencil",
  "email": "mail",
  "export": "download",
  "export-no-circle": "download",
  "file-excel": "file-spreadsheet",
  "hamburger": "menu",
  "left": "chevron-left",
  "right": "chevron-right",
  "menu": "ellipsis",
  "more_vert": "ellipsis-vertical",
  "question": "circle-question-mark",
  "spinner": "loader-circle",
  "survey": "clipboard-list",
  "survey-disabled": "clipboard-x",
  "trash1": "trash",
  "trash2": "trash",
  "tune": "sliders-horizontal",
  "placeholder": "image",
  "logo": "clipboard-list",
  "logout": "log-out",
};

export function iconNode(name: string): IconNode | null {
  return ICONS[ALIASES[name] || name] || null;
}
